var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 6.04167H7M4.66667 8.08333H8.75M7 12.75C9.89949 12.75 12.25 10.3995 12.25 7.5C12.25 4.60051 9.89949 2.25 7 2.25C4.10051 2.25 1.75 4.60051 1.75 7.5C1.75 8.19833 1.88635 8.86482 2.13387 9.4743C2.18124 9.59094 2.20493 9.64927 2.2155 9.69641C2.22583 9.74253 2.22961 9.77666 2.22962 9.82392C2.22963 9.87224 2.22086 9.92487 2.20331 10.0301L1.85741 12.1056C1.82118 12.3229 1.80307 12.4316 1.83678 12.5101C1.86628 12.5789 1.92108 12.6337 1.98986 12.6632C2.06844 12.6969 2.17711 12.6788 2.39444 12.6426L4.46988 12.2967C4.57513 12.2791 4.62776 12.2704 4.67608 12.2704C4.72334 12.2704 4.75747 12.2742 4.80359 12.2845C4.85073 12.2951 4.90906 12.3188 5.0257 12.3661C5.63518 12.6137 6.30167 12.75 7 12.75Z",
    stroke: "#082CAF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9fc1e8e9728b46d32aba08e27cee12a6.svg";
export { ForwardRef as ReactComponent };